<template>
  <v-app>
    <router-view></router-view>
    <app-notifications />
    <pwa-update-banner />
    <ios-open-in-app-banner />
  </v-app>
</template>

<script>
import AppNotifications from "./components/ui/AppNotifications.vue";
import PwaUpdateBanner from "./components/ui/PwaUpdateBanner.vue";
import IosOpenInAppBanner from "./components/ui/IosOpenInAppBanner.vue";

export default {
  components: {
    AppNotifications,
    PwaUpdateBanner,
    IosOpenInAppBanner,
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Roboto:wght@400;700&display=swap");

* {
  box-sizing: border-box;
}

html {
  font-family: "Roboto", sans-serif;
  touch-action: manipulation;
}

body {
  margin: 0;
  touch-action: manipulation;
}
</style>
